import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "icon-check",
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path id=\"check\" d=\"M13.076,5.039a.979.979,0,1,1,1.4,1.371L9.261,12.926a.979.979,0,0,1-1.41.026L4.4,9.5A.979.979,0,1,1,5.781,8.113l2.734,2.733,4.535-5.778a.308.308,0,0,1,.026-.029Z\" transform=\"translate(5.915 5.755)\" fill=\"#fff\" fill-rule=\"evenodd\"></path><rect id=\"base\" width=\"15\" height=\"15\" transform=\"translate(8 7.5)\" fill=\"none\"></rect><g id=\"Ellipse_206\" data-name=\"Ellipse 206\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\"><circle cx=\"15\" cy=\"15\" r=\"15\" stroke=\"none\"></circle><circle cx=\"15\" cy=\"15\" r=\"14\" fill=\"none\"></circle></g>", 3)
  ])))
}
export default { render: render }